// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export class SoundSett {
    public EnableSounds = true;
    public DisableStartEndSound = true;

    public EnableSound_welcome = false;
    public EnableSound_finish = false;
}
